import { useRouter } from 'next/router';
import styled from 'styled-components';
import type {
  HygienePageLeftSlotContent,
  HygienePageRightSlotContents,
  HygienePage as HygienePageSchema,
  TextTransform,
} from '@amplience/content-types/typings/s-hygiene-page-layout';
import type { HandlebarTemplateProps } from '@storefront/lib-global/globalComponents/handlebarTemplate';
import { useTextTransform } from '@storefront/lib-global/partials/textTransform';
import { TypographyStyles, maxWidthPartial, media, spacing } from '@storefront/lib-global/stylings';
import { renderAmplienceSlotComponents } from '@storefront/lib-global/utils/amplienceUtils';
import { getLocalizedValue } from '@storefront/lib-global/utils/transformers';
import { createHygienePageAmplienceComponents } from './hygienePageAmplienceComponents.utils';

export type HygienePageProps = HygienePageSchema & {
  handlebarComponents: HandlebarTemplateProps[] | null;
};

export type HygieneComponentPropsType = HygienePageRightSlotContents | HygienePageLeftSlotContent;

const S = {
  Container: styled.div`
    ${maxWidthPartial({ withPaddingXL: true })}
    margin-bottom: ${spacing.L};
    margin-top: ${spacing.L};

    @media ${media.greaterThan('lg')} {
      margin-bottom: 80px;
      margin-top: 80px;
    }
  `,
  HygienePageContentContainer: styled.div`
    @media ${media.greaterThan('lg')} {
      display: flex;
      flex-grow: unset;
    }
  `,
  HygienePageHeading: styled.h1<{ $textTransform: TextTransform }>`
    ${TypographyStyles.Headings.H1}
    margin-bottom: ${spacing.S};
    margin-top: ${spacing.L};
    ${({ $textTransform }) => useTextTransform($textTransform)}

    @media ${media.greaterThan('lg')} {
      margin-bottom: ${spacing.L};
      margin-top: unset;
    }
  `,
  RightSection: styled.section`
    width: 100%;
    > div {
      margin-left: 0;
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
    }
  `,
  LeftSection: styled.section`
    margin-bottom: 50px;

    @media ${media.greaterThan('lg')} {
      margin-bottom: unset;
      margin-right: 81px;
      max-width: 333px;
    }
  `,
};
export function HygienePageLayout({ mainHeading, slotContent, textTransform, handlebarComponents }: HygienePageProps) {
  const { locale } = useRouter();

  return (
    <S.Container>
      <S.HygienePageHeading $textTransform={textTransform ?? 'UPPERCASE'}>
        {getLocalizedValue(mainHeading)}
      </S.HygienePageHeading>
      <S.HygienePageContentContainer>
        <S.LeftSection>
          {slotContent &&
            renderAmplienceSlotComponents(
              [slotContent.LeftContent],
              { ...createHygienePageAmplienceComponents([slotContent.LeftContent] as unknown as []) },
              handlebarComponents,
              locale,
            )}
        </S.LeftSection>
        <S.RightSection>
          {slotContent &&
            renderAmplienceSlotComponents(
              slotContent.RightContent.pageContent,
              { ...createHygienePageAmplienceComponents(slotContent.RightContent.pageContent as unknown as []) },
              handlebarComponents,
              locale,
            )}
        </S.RightSection>
      </S.HygienePageContentContainer>
    </S.Container>
  );
}
